module.exports = __webpack_public_path__ + "static/media/changeArrow.2978aabc.svg";